/**
 * CSS-only canvas scaling. The canvas keeps its internal resolution
 * (canvas.width / canvas.height) so render code stays pixel-stable; we
 * only resize the rendered output via CSS to fill the browser window.
 *
 * Picks the largest integer scale that fits when the window is at least
 * native size (crisp pixels at 2x/3x/4x). If the window is smaller than
 * native (which is unusual but possible), falls back to the fractional
 * scale so the game still fits inside the viewport instead of overflowing.
 */

export function computeCssScale(
  canvasW: number,
  canvasH: number,
  winW: number,
  winH: number,
): number {
  const raw = Math.min(winW / canvasW, winH / canvasH);
  return raw >= 1 ? Math.floor(raw) : raw;
}
